import React from 'react'
import { FormGroup, Row, Col } from 'react-bootstrap'
import { ValidationError, Button, Label } from 'fw/components'
import { Form, TextBox, CheckBox } from 'fw/forms'
import News from './News'
import * as API from 'modules/app/API'
import * as Block from 'fw/globals/Block'
import * as FW from 'fw/system/FW'

const ERROR_DELAY = 6000;

class Login extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {

		const rm = {
			login: "",
			rememberme: false
		}

		if (localStorage.getItem('rememberme') === 'true') {
			rm.login = localStorage.getItem('login');
			rm.rememberme = true;
		}

		return {
			error: null,
			invalidLogin: false,
			listNews: "",
			showNews: FW.getSettings().showNews,
			version: FW.getSettings().version,
			form: {
				login: rm.login,
				rememberme: rm.rememberme
			}
		}
	}

	signIn = (e) => {
		const me = this;

		const rq = {
			login: this.state.form.login,
		}

		this.saveRememberMe();

		// Spinner
		this.setState({ error: null })

		API.Core.post('/security/authentication/startLogin', rq,
			{
				success: (sr) => {
					// Load app state
					localStorage.setItem('login', sr.data.login);

					// Redirect to landing page
					this.props.history.push('/public/completeLogin');
				},
				error: (sr) => {
					if (sr.error.errorCode === "INVALID_LOGIN") {
						this.setState({ invalidLogin: true })
					}
					else {
						this.setState({ error: sr.error })

						setTimeout(function () {
							me.setState({ error: "" })
						}, ERROR_DELAY);
					}
				},
				exception: (err) => {
					this.setState({
						error: { errorMessage: "Oops! Something went wrong. Please contact administrator." }
					});
				}
			});
	}

	saveRememberMe = () => {
		if (this.state.form.rememberme) {
			localStorage.setItem('rememberme', 'true');
			localStorage.setItem('login', this.state.form.login);
		}
		else {
			if (localStorage.getItem('rememberme') === 'true' &&
				localStorage.getItem('login') === this.state.form.login) {
				localStorage.setItem('rememberme', 'false');
			}
		}
	}

	onChange = (form) => {
		this.setState({ form });
	}

	componentDidMount() {
		// Set focus
		this.loginTextBox.focus();

		// Get news
		API.Core.get('/app/query/getNews', null,
			{
				success: (sr) => {
					this.setState({ listNews: sr.data });
				},
				exception: (sr) => {
					console.error("Error reading news.", sr);
				}
			},
			{
				block: false
			});
	}

	renderNews() {
		if (this.state.showNews && this.state.listNews.length > 0) {
			return (
				<div className="pull-left">
					<News content={this.state.listNews} />
				</div>
			)
		}
		else
			return (<div className="pull-left"> <News content={""} /></div>)
	}

	render() {
		return (
			<React.Fragment>
				<ValidationError error={this.state.error} />
				<Block.Block ref={Block.hookref}>
					<Row>
						<Col sm={6}>
							{this.renderNews()}
						</Col>
						<Col sm={6}>
							<p className="login-box-heading">Sign in to start your session</p>
							{this.state.invalidLogin ?
								<div className="login-box-password-notation">
									<p><strong>Oops!...It looks like we couldn't find your user name.
								<br /><br />
										Please retry or select <a href='/public/registration'>Create New Account</a>.
										</strong></p>
								</div> : null}
							<Form
								onSubmit={this.signIn}
								values={this.state.form}
								onChange={this.onChange}>
								<FormGroup>
									<Label>User Name</Label>
								</FormGroup>
								<FormGroup>
									<TextBox name="login" placeholder="Please enter your user name" required ref={(c) => { this.loginTextBox = c; }} />
								</FormGroup>
								<FormGroup>
									<CheckBox name="rememberme" label="Remember me next time" />
								</FormGroup>
								<FormGroup>
									<Row>
										<Col xs={6}>
											<a href='/public/registration'>Create New Account</a>
										</Col>
										<Col xs={6} className="text-right">
											<Button id="btnSignIn" type="submit" bsStyle="primary">Next</Button>
										</Col>
									</Row>
								</FormGroup>
							</Form>
						</Col>
					</Row>
				</Block.Block>
				<div className="text-center" >Version: {this.state.version} / {process.env.REACT_APP_ENV}</div>
			</React.Fragment>
		);
	}
}

export default Login;



// WEBPACK FOOTER //
// ./src/areas/public/login/Login.js